import { clearInfluencer } from '~/composables/influencer'

/**
 * Drops the cached influencer profile the moment its customer is no longer the one signed in.
 *
 * Only the account layout refetches it, but a sign-out can happen anywhere — another tab, an
 * expired session — and the profile (payout account included) would stay in this tab's memory,
 * hidden but readable, until the next account visit. Only clears, never fetches: no `me` request
 * on every page.
 */
export default defineNuxtPlugin({
  name: 'influencer',
  setup() {
    // Resolved here, in setup, where the Nuxt instance is active (the auth plugin runs first).
    const auth = useAuth()
    if (!auth)
      return
    const owner = useState<string | null>('affiliate:influencer:customer', () => null)
    watch(() => auth.activeCustomer.value?.id, (id) => {
      if (owner.value && owner.value !== (id != null ? String(id) : null))
        clearInfluencer()
    })
  },
})
